import { enrichRecord } from "../../utils/recordUtils";

export const MOBILE_LIST_ICONS = {
  student:
    "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/People/Person%20Raising%20Hand.png",
  teacher_male: "/images/teacher_3d_light.png",
  teacher_female: "/images/woman_teacher_3d_light.png",
  prayer: "/images/prayer_3d.png",
};
const KOREAN_NUMERIC_COLLATOR = new Intl.Collator("ko", {
  numeric: true,
  sensitivity: "base",
});

export const MOBILE_FORM_LABEL_CLASS = "text-xs font-bold text-gray-500 ml-1 mb-1.5 block";
export const MOBILE_FORM_INPUT_BASE_CLASS =
  "bg-white border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 transition";
export const MOBILE_FORM_TEXTAREA_CLASS =
  "bg-[#F9F9F8] border border-gray-200 p-3.5 rounded-2xl font-medium focus:outline-none focus:border-[#354F38] transition resize-none h-32 leading-relaxed";
export const MOBILE_GENDER_TOGGLE_WRAPPER_CLASS = "flex bg-gray-100 p-1.5 rounded-2xl flex-shrink-0";
export const MOBILE_MODAL_HEADER_SECONDARY_BUTTON_CLASS = "text-gray-500 font-bold text-base";
export const MOBILE_MODAL_HEADER_PRIMARY_BUTTON_CLASS = "font-bold text-base text-[#354F38]";
export const MOBILE_DANGER_OUTLINE_BUTTON_CLASS =
  "w-full py-4 text-rose-500 font-bold border border-rose-200 rounded-2xl hover:bg-rose-50 transition mt-4";
export const MOBILE_DETAIL_SECTION_TITLE_CLASS = "text-sm font-black text-gray-400 pl-1";
export const MOBILE_DETAIL_CARD_CLASS = "bg-white rounded-3xl p-5 shadow-sm border border-gray-100";
export const MOBILE_DETAIL_INFO_ROW_CLASS =
  "flex justify-between items-center border-b border-gray-50 pb-3";
export const MOBILE_DETAIL_SUBTITLE_CLASS = "text-xs font-black text-gray-400";
export const MOBILE_DETAIL_TIMELINE_LABEL_CLASS = "text-xs font-bold text-gray-400 mb-0.5";
export const MOBILE_DETAIL_ACTIVITY_CHIP_CLASS =
  "bg-gray-50 rounded-xl px-3 py-2 flex items-center gap-2";
export const MOBILE_DETAIL_EMPTY_CARD_CLASS = "bg-gray-50 rounded-3xl p-6 text-center";
export const MOBILE_DETAIL_LOG_ITEM_CARD_CLASS =
  "bg-white rounded-2xl p-4 shadow-sm border border-gray-100";
export const MOBILE_DETAIL_ACTION_ROW_CLASS =
  "flex justify-between items-center p-2 -mx-2 cursor-pointer hover:bg-gray-50 rounded-lg transition";
export const MOBILE_DETAIL_CANCEL_EDIT_BUTTON_CLASS =
  "text-xs font-bold text-gray-400 hover:text-rose-500 transition";
export const MOBILE_DETAIL_VISIT_EDITOR_INPUT_CLASS =
  "flex-1 px-4 py-3 bg-gray-50 rounded-2xl text-sm font-medium focus:outline-none focus:ring-2 focus:ring-orange-200";
export const MOBILE_DETAIL_VISIT_EDITOR_SUBMIT_BUTTON_CLASS =
  "px-4 py-3 bg-orange-500 text-white rounded-2xl font-bold text-sm flex items-center gap-1 shadow-lg shadow-orange-500/20 active:scale-95 transition";
export const MOBILE_DETAIL_VISIT_LOG_ACTION_EDIT_BUTTON_CLASS =
  "p-1.5 text-gray-400 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition";
export const MOBILE_DETAIL_VISIT_LOG_ACTION_DELETE_BUTTON_CLASS =
  "p-1.5 text-gray-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition";
export const MOBILE_DETAIL_VISIT_SHOW_MORE_BUTTON_CLASS =
  "w-full py-3 text-center text-sm font-bold text-orange-500 bg-orange-50 rounded-2xl hover:bg-orange-100 active:scale-[0.98] transition";
export const MOBILE_DETAIL_VISIT_TYPE_ICON_WRAPPER_BASE_CLASS =
  "w-10 h-10 rounded-xl flex items-center justify-center shrink-0";
export const MOBILE_DETAIL_VISIT_TYPE_BUTTON_BASE_CLASS =
  "px-3 py-1.5 rounded-full text-xs font-bold transition";
export const MOBILE_LIST_SEARCH_INPUT_CLASS =
  "w-full pl-8 pr-3 h-9 bg-white border border-gray-200 rounded-xl text-xs font-bold focus:outline-none focus:ring-1 focus:ring-[#354F38] shadow-sm";
export const MOBILE_LIST_ROOT_CONTAINER_CLASS = "flex flex-col h-full bg-[#F0F0EB] relative";
export const MOBILE_LIST_STICKY_HEADER_CLASS = "sticky top-0 z-20 bg-[#F0F0EB] px-2.5 py-1.5";
export const MOBILE_LIST_SCROLL_AREA_CLASS = "flex-1 overflow-y-auto px-2.5 pb-24";
export const MOBILE_LIST_STACK_CLASS = "space-y-1.5";
export const MOBILE_LIST_ITEM_INFO_CLASS = "flex-1 min-w-0 flex items-center gap-1.5 overflow-hidden";
export const MOBILE_LIST_ITEM_INLINE_ROW_CLASS = "flex-1 min-w-0 flex items-center gap-0.5 overflow-hidden";
export const MOBILE_LIST_ITEM_TITLE_CLASS = "font-bold text-gray-900 text-sm truncate shrink-0 max-w-[64px]";
export const MOBILE_LIST_ITEM_SUBTEXT_CLASS = "text-[10px] text-gray-500 truncate shrink-0 max-w-[36px]";
export const MOBILE_LIST_INLINE_DIVIDER_CLASS = "text-[10px] text-gray-300 shrink-0";
export const MOBILE_LIST_META_ATTENDANCE_TEXT_CLASS =
  "text-[10px] text-emerald-600 font-bold whitespace-nowrap shrink-0";
export const MOBILE_LIST_META_VISIT_TEXT_CLASS =
  "text-[10px] text-orange-600 font-bold whitespace-nowrap shrink-0";
export const MOBILE_LIST_CHEVRON_CLASS = "text-gray-300 -rotate-90 shrink-0";
export const MOBILE_LIST_FILTER_TRIGGER_BUTTON_BASE_CLASS =
  "h-9 px-2.5 border rounded-xl text-[11px] font-bold shadow-sm flex items-center gap-1 active:scale-95 transition";
export const MOBILE_LIST_FILTER_TRIGGER_BUTTON_INACTIVE_CLASS = "bg-white border-gray-200 text-gray-600";
export const MOBILE_LIST_ACTIVE_FILTER_CHIPS_ROW_CLASS =
  "flex items-center gap-1.5 mt-2.5 overflow-x-auto pb-1 no-scrollbar";
export const MOBILE_LIST_ACTIVE_FILTER_CHIP_BUTTON_CLASS =
  "flex-shrink-0 px-2.5 py-1.5 rounded-lg text-[10px] font-black flex items-center gap-1 shadow-sm border";
export const MOBILE_LIST_CLEAR_FILTER_BUTTON_CLASS =
  "flex-shrink-0 px-2.5 py-1.5 bg-gray-100 text-gray-500 rounded-lg text-[10px] font-black shadow-sm";
export const MOBILE_LIST_COUNT_BADGE_CLASS =
  "shrink-0 bg-white border border-gray-200 h-9 px-2.5 rounded-xl flex items-center justify-center shadow-sm";
export const MOBILE_LIST_COUNT_TEXT_CLASS = "text-xs font-bold text-gray-500";
export const MOBILE_LIST_COUNT_HIGHLIGHT_CLASS = "text-[#354F38] text-sm font-black";
export const MOBILE_LIST_ITEM_CARD_CLASS =
  "bg-white rounded-2xl p-2.5 shadow-sm border border-gray-50 flex items-center gap-2.5 active:scale-[0.98] transition cursor-pointer";
export const MOBILE_LIST_ITEM_AVATAR_WRAPPER_CLASS =
  "w-10 h-10 rounded-2xl bg-gray-50 overflow-hidden shrink-0 border border-gray-100";
export const MOBILE_LIST_EMPTY_STATE_CLASS = "flex flex-col items-center justify-center py-20 text-gray-400";
export const MOBILE_DEPT_DROPDOWN_TRIGGER_BASE_CLASS =
  "w-full bg-white border transition-all p-3.5 rounded-2xl font-bold flex justify-between items-center cursor-pointer";
export const MOBILE_DEPT_DROPDOWN_PANEL_CLASS =
  "bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm space-y-1 p-2";
export const MOBILE_FAITH_STATE_BUTTON_BASE_CLASS =
  "w-full py-2.5 text-xs font-bold rounded-xl border transition shadow-sm flex items-center justify-center";

export const MOBILE_FAITH_STATE_OPTIONS = [
  {
    label: "초신자",
    active: "bg-amber-400 text-white border-amber-400",
    inactive: "bg-white text-amber-500 border-amber-200 hover:bg-amber-50",
  },
  {
    label: "기존신자",
    active: "bg-[#354F38] text-white border-[#354F38]",
    inactive: "bg-white text-[#354F38] border-[#354F38]/30 hover:bg-[#354F38]/5",
  },
  {
    label: "양육중",
    active: "bg-blue-500 text-white border-blue-500",
    inactive: "bg-white text-blue-500 border-blue-200 hover:bg-blue-50",
  },
  {
    label: "시험듦",
    active: "bg-rose-500 text-white border-rose-500",
    inactive: "bg-white text-rose-500 border-rose-200 hover:bg-rose-50",
  },
  {
    label: "장기결석",
    active: "bg-gray-400 text-white border-gray-400",
    inactive: "bg-white text-gray-400 border-gray-200 hover:bg-gray-50",
  },
];

export function getFaithStateBadgeClass(faithState) {
  if (faithState === "초신자") return "bg-amber-400 text-white";
  if (faithState === "기존신자") return "bg-[#354F38] text-white";
  if (faithState === "양육중") return "bg-blue-500 text-white";
  if (faithState === "시험듦") return "bg-rose-500 text-white";
  if (faithState === "장기결석") return "bg-gray-400 text-white";
  return "bg-gray-50 text-gray-800";
}

export function getMobileGenderButtonClass(selectedGender, targetGender) {
  const activeClass =
    targetGender === "남"
      ? "bg-white text-blue-600 shadow-sm ring-1 ring-black/5"
      : "bg-white text-rose-500 shadow-sm ring-1 ring-black/5";
  const inactiveClass = "text-gray-400 hover:text-gray-600";
  return `px-4 rounded-xl text-sm font-bold transition-all ${selectedGender === targetGender ? activeClass : inactiveClass
    }`;
}

export function getMobileVisitEditorCardClass(isEditing) {
  return `rounded-3xl p-4 shadow-sm border ${isEditing ? "bg-orange-50 border-orange-200" : "bg-white border-gray-100"
    }`;
}

export function getMobileVisitTypeButtonClass(activeType, targetType) {
  return `${MOBILE_DETAIL_VISIT_TYPE_BUTTON_BASE_CLASS} ${activeType === targetType
    ? "bg-orange-500 text-white shadow-sm"
    : "bg-gray-100 text-gray-500 hover:bg-gray-200"
    }`;
}

export function getMobileVisitTypeIconWrapperClass(type) {
  let bgClass = "bg-gray-50";
  if (type === "면담") bgClass = "bg-emerald-50";
  else if (type === "전화") bgClass = "bg-blue-50";
  else if (type === "문자") bgClass = "bg-amber-50";
  else if (type === "기도") bgClass = "bg-purple-50";
  else if (type === "교제") bgClass = "bg-rose-50";
  return `${MOBILE_DETAIL_VISIT_TYPE_ICON_WRAPPER_BASE_CLASS} ${bgClass}`;
}

export function getMobileVisitTypeIconSrc(type) {
  if (type === "면담") return "/images/Memo.png";
  if (type === "전화") return "/images/Telephone_Receiver.png";
  if (type === "문자") return "/images/Speech_Balloon.png";
  if (type === "기도") return "/images/prayer_3d.png";
  if (type === "교제") return "/images/Hot_Beverage.png";
  return "/images/Memo.png";
}

export function getMobileDeptDropdownTriggerClass(isOpen) {
  return `${MOBILE_DEPT_DROPDOWN_TRIGGER_BASE_CLASS} ${isOpen ? "border-[#354F38] ring-4 ring-[#354F38]/10" : "border-gray-200"
    }`;
}

export function getMobileDeptOptionButtonClass(currentValue, option) {
  const isSelected = String(currentValue || "").trim() === option;
  return `w-full text-left p-3 rounded-xl font-bold text-sm transition flex items-center justify-between ${isSelected ? "bg-[#E3F9E5] text-[#354F38]" : "text-gray-600 hover:bg-gray-50"
    }`;
}

export function getMobileFaithStateButtonClass(isActive, stateItem) {
  return `${MOBILE_FAITH_STATE_BUTTON_BASE_CLASS} ${isActive ? stateItem.active : stateItem.inactive
    }`;
}

export function getMobileActiveFilterStyle(themeColor) {
  return {
    backgroundColor: `${themeColor}1A`,
    borderColor: `${themeColor}4D`,
    color: themeColor,
  };
}

export function getMobileListSortOptions(isTeacher) {
  return isTeacher
    ? [
      { value: "name", label: "이름순" },
      { value: "responsibility", label: "담당순" },
      { value: "grade", label: "직분순" },
      { value: "department", label: "부서순" },
    ]
    : [
      { value: "grade", label: "학년순" },
      { value: "class", label: "반별순" },
      { value: "name", label: "이름순" },
      { value: "department", label: "부서순" },
    ];
}

export function getMobileAttendanceFilterLabel(attendanceFilter) {
  return attendanceFilter === "2weeks" ? "2주+ 미출석" : "한달+ 미출석";
}

export function getMobileActiveFilterChips({ faithFilter, attendanceFilter, genderFilter }) {
  const chips = [];

  if (faithFilter !== "all") {
    chips.push({ key: "faith", label: faithFilter });
  }

  if (attendanceFilter !== "all") {
    chips.push({
      key: "attendance",
      label: getMobileAttendanceFilterLabel(attendanceFilter),
    });
  }

  if (genderFilter !== "all") {
    chips.push({ key: "gender", label: genderFilter });
  }

  return chips;
}


export function getMobileFilterTriggerButtonClass(hasActiveFilters) {
  return `${MOBILE_LIST_FILTER_TRIGGER_BUTTON_BASE_CLASS} ${
    hasActiveFilters ? "" : MOBILE_LIST_FILTER_TRIGGER_BUTTON_INACTIVE_CLASS
  }`.trim();
}

const DEFAULT_DEPT_COLORS = {
  영아부: "bg-pink-400",
  유아부: "bg-yellow-400",
  유치부: "bg-orange-400",
  유년부: "bg-sky-400",
  초등부: "bg-blue-500",
  중등부: "bg-purple-500",
  고등부: "bg-indigo-500",
  청년부: "bg-teal-600",
  장년부: "bg-gray-600",
  기타: "bg-gray-400",
};

export function buildDepartmentOptions({ myDepartments, userProfile }) {
  let depts = [];

  if (userProfile?.deptName) depts.push(String(userProfile.deptName).trim());

  if (Array.isArray(myDepartments)) {
    myDepartments.forEach((dept) => {
      const clean = String(dept).trim();
      if (clean && clean !== String(userProfile?.deptName || "").trim()) {
        depts.push(clean);
      }
    });
  } else if (myDepartments && typeof myDepartments === "object") {
    Object.keys(myDepartments).forEach((dept) => {
      const clean = String(dept).trim();
      if (clean && clean !== String(userProfile?.deptName || "").trim()) {
        depts.push(clean);
      }
    });
  }

  depts = [...new Set(depts.filter(Boolean))];
  depts.push("기타(직접 입력)");
  return depts;
}

export function getDefaultDepartmentValue({
  departmentOptions,
  selectedDepartment,
  userProfile,
}) {
  if (
    departmentOptions.length === 1 ||
    (departmentOptions.length === 2 && departmentOptions[1] === "기타(직접 입력)")
  ) {
    return departmentOptions[0];
  }

  if (selectedDepartment && selectedDepartment !== "All" && selectedDepartment !== "전체") {
    return selectedDepartment;
  }

  return departmentOptions[0] || userProfile?.deptName || "청년부";
}

export function getDeptColorClass(deptName, userProfile) {
  if (userProfile?.departmentColors?.[deptName]) {
    return userProfile.departmentColors[deptName];
  }
  return DEFAULT_DEPT_COLORS[deptName] || "bg-[#354F38]";
}

function getGradeIndex(charge) {
  if (!charge) return 9999;

  const match = charge.match(/(초|중|고)\D*(\d)/);
  if (match) {
    const school = match[1];
    const grade = parseInt(match[2], 10);
    let base = 0;
    if (school === "초") base = 10;
    else if (school === "중") base = 20;
    else if (school === "고") base = 30;
    return base + grade;
  }

  if (charge.includes("영아")) return 1;
  if (charge.includes("유아")) return 2;
  if (charge.includes("유치")) return 3;
  if (charge.includes("청년")) return 40;
  if (charge.includes("장년")) return 50;
  return 9999;
}

function getAcademicGradeWeight(value) {
  if (!value) return 9999;
  const normalized = String(value).trim();
  if (!normalized) return 9999;

  const schoolGradeMatch = normalized.match(/(초|중|고)\s*(\d)/);
  if (schoolGradeMatch) {
    const school = schoolGradeMatch[1];
    const grade = parseInt(schoolGradeMatch[2], 10);
    const base = school === "초" ? 10 : school === "중" ? 20 : 30;
    return base + grade;
  }

  return getGradeIndex(normalized);
}

function getClassSortWeight(classStr) {
  if (!classStr) return 9999;
  const normalized = String(classStr).trim();
  if (!normalized) return 9999;

  const gradeWeight = getAcademicGradeWeight(normalized);
  const classMatch = normalized.match(/(\d+)\s*반$/);

  if (gradeWeight !== 9999 && classMatch) {
    return gradeWeight * 100 + parseInt(classMatch[1], 10);
  }

  if (classMatch) return parseInt(classMatch[1], 10);

  if (gradeWeight !== 9999) return gradeWeight * 100;

  const anyNumberMatch = normalized.match(/(\d+)/);
  if (anyNumberMatch) return parseInt(anyNumberMatch[1], 10);

  return 9999;
}

function getStudentGradeSortWeight(item) {
  const classGradeWeight = getAcademicGradeWeight(item?.class || "");
  if (classGradeWeight !== 9999) return classGradeWeight;
  const deptGradeWeight = getAcademicGradeWeight(item?.grade || item?.department || "");
  if (deptGradeWeight !== 9999) return deptGradeWeight;
  return getGradeIndex(item?.grade || item?.department || "");
}

export function buildFilteredItems({
  isTeacher,
  students,
  teachers,
  selectedDepartment,
  searchTerm,
  matchSearch,
  attendanceLogs,
  visitLogs,
  sortKey, // legacy
  sortOrder,
  faithFilter = "all",
  attendanceFilter = "all",
  genderFilter = "all",
}) {
  const items = isTeacher ? teachers : students;
  const deptFilter = selectedDepartment || "All";

  const today = new Date();
  const processed = items
    .filter((item) => {
      // 1. Search
      const matchesSearch =
        matchSearch(item.name || "", searchTerm) ||
        (item.phone && item.phone.includes(searchTerm));
      if (!matchesSearch) return false;

      // 2. Department
      const matchesDept =
        deptFilter === "All" ||
        deptFilter === "전체" ||
        (item.grade && item.grade.includes(deptFilter)) ||
        (item.deptName && item.deptName.includes(deptFilter)) ||
        (item.charge && item.charge.includes(deptFilter));
      if (!matchesDept) return false;

      // 3. Faith State
      if (faithFilter !== "all" && item.faithState !== faithFilter) return false;

      // 4. Gender
      if (genderFilter !== "all" && item.gender !== genderFilter) return false;

      return true;
    })
    .map((item) => enrichRecord(item, attendanceLogs, visitLogs))
    .filter((item) => {
      // 5. Attendance Recency Filter
      if (attendanceFilter === "2weeks") {
        if (!item.lastAttendance) return true;
        const diff = (today - new Date(item.lastAttendance)) / (1000 * 60 * 60 * 24);
        return diff >= 14;
      }
      if (attendanceFilter === "4weeks") {
        if (!item.lastAttendance) return true;
        const diff = (today - new Date(item.lastAttendance)) / (1000 * 60 * 60 * 24);
        return diff >= 28;
      }
      return true;
    });

  return [...processed].sort((a, b) => {
    let comparison = 0;
    const sortType = sortKey; // Maintain compatibility
    if (sortType === "grade") {
      if (isTeacher) {
        comparison = (a.role || "").localeCompare(b.role || "");
      } else {
        const gradeWeightA = getStudentGradeSortWeight(a);
        const gradeWeightB = getStudentGradeSortWeight(b);
        if (gradeWeightA !== gradeWeightB) {
          comparison = gradeWeightA - gradeWeightB;
        } else {
          comparison = KOREAN_NUMERIC_COLLATOR.compare(a.class || "", b.class || "");
        }
      }
    } else if (sortType === "class") {
      const classWeightA = getClassSortWeight(a.class || "");
      const classWeightB = getClassSortWeight(b.class || "");
      if (classWeightA !== classWeightB) {
        comparison = classWeightA - classWeightB;
      } else {
        comparison = KOREAN_NUMERIC_COLLATOR.compare(a.class || "", b.class || "");
      }
    } else if (sortType === "responsibility") {
      const valA = a.responsibility || a.charge || "";
      const valB = b.responsibility || b.charge || "";
      const indexA = getGradeIndex(valA);
      const indexB = getGradeIndex(valB);
      comparison = indexA !== indexB ? indexA - indexB : valA.localeCompare(valB);
    } else if (sortType === "department") {
      comparison = (a.grade || "").localeCompare(b.grade || "");
    } else {
      comparison = (a.name || "").localeCompare(b.name || "");
    }

    return sortOrder === "desc" ? -comparison : comparison;
  });
}

export function formatCompactDate(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const yy = String(d.getFullYear()).slice(2);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

function formatMiniDate(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${mm}.${dd}`;
}

export function getMobileItemClassLabel(item) {
  const className = String(item?.class || "").trim();
  if (className) {
    const normalizedClass = className.replace(/\s*반$/, "").trim();
    return normalizedClass || className;
  }

  const chargeName = String(item?.charge || item?.responsibility || "").trim();
  if (chargeName) return chargeName;

  return "-";
}

export function getMobileItemAttendanceLabel(item) {
  return item?.lastAttendance ? formatMiniDate(item.lastAttendance) : "-";
}

export function getMobileItemVisitLabel(item) {
  return item?.lastVisit ? formatMiniDate(item.lastVisit) : "-";
}
